import { Stack } from "@mui/material";
import { ComparePlansButton } from "./Buttons/ComparePlans";
import { WhatsCoveredButton } from "./Buttons/WhatsCovered";
import { ValuationReportButton } from "./Buttons/ValuationReport";

interface Props {
  isD2C?: boolean;
  documentUrl?: string;
  openWhatsCoveredModal?(state: boolean): void;
  openComparePlansModal(state: boolean): void;
}

export function PersonalizedQuotesButtonsRow({
  isD2C,
  documentUrl,
  openWhatsCoveredModal,
  openComparePlansModal,
}: Props) {
  return (
    <Stack
      position="relative"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      sx={{
        width: "100%",
        gap: 2,
      }}>
      <ComparePlansButton
        openComparePlansModal={openComparePlansModal}
        isD2C={isD2C}
      />
      {!isD2C && (
        <>
          {documentUrl && <ValuationReportButton documentUrl={documentUrl} />}
          {openWhatsCoveredModal && (
            <WhatsCoveredButton openWhatsCoveredModal={openWhatsCoveredModal} />
          )}
        </>
      )}
    </Stack>
  );
}
